import React from 'react'
import {Link, graphql, useStaticQuery} from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

import * as footerStyles from './footer.module.scss'
import Youtube from '../images/youtube-play.svg'
import Facebook from '../images/facebook-square.svg'
import Instagram from '../images/instagram.svg'
import Soundcloud from '../images/soundcloud2.svg'
import Pinterest from '../images/pinterest2.svg'
import { OutboundLink } from 'gatsby-plugin-google-gtag';

const Footer = () => {
    const data = useStaticQuery(graphql`
    query {
        contentfulAsset (title: {eq: "logo small dkgrey"}) {
            imgixImage {
                gatsbyImageData (layout: CONSTRAINED, width: 200, imgixParams: {q: 75})
              }
        }
      }
    `)
    return (
        <footer className={footerStyles.footer}>
            <div className={footerStyles.container}>
            <div className={footerStyles.column}>
                <Link className={footerStyles.item} to="/vegan-life/all-recipes">Recipe Index</Link>
                <Link className={footerStyles.item} to="/vegan-life/health">Vegan health</Link>
                <Link className={footerStyles.item} to="/vegan-life/recipes">Vegan recipes</Link>
                <Link className={footerStyles.item} to="/travel">Travel articles</Link>
                <Link className={footerStyles.item} to="/music">Music mixes</Link>
            </div>
            <div className={footerStyles.column}>
                
                <Link className={footerStyles.item} to="/videos">Videos</Link>
                <Link className={footerStyles.item} to="/stories">Web Stories</Link>
                <Link className={footerStyles.item} to="/about">About</Link>
                <Link className={footerStyles.item} to="/terms">Terms and Conditions</Link>
            </div>
            <div className={`${footerStyles.column} ${footerStyles.columnEnd}`}>
                <div className={footerStyles.socialLine}>
                    <OutboundLink href="https://www.pinterest.com/msstephsunshine" aria-label="Pinterest"><Pinterest className={footerStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://www.youtube.com/channel/UCjKLqaZuRg20F46v8yCz4wA" aria-label="YouTube"><Youtube className={footerStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://soundcloud.com/steph-sunshine-2" aria-label="Soundcloud"><Soundcloud className={footerStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://www.instagram.com/msstephsunshine/" aria-label="Instagram"><Instagram className={footerStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://www.facebook.com/MsStephSunshine/" aria-label="Facebook"><Facebook className={footerStyles.socialIcon} /></OutboundLink>

                </div>
                <div className={footerStyles.copyrightLine}>
                    &copy; {new Date().getFullYear()} Steph Sunshine
                    <GatsbyImage
                        image={data.contentfulAsset.imgixImage.gatsbyImageData}
                        className={footerStyles.logo}
                        alt="Steph Sunshine small logo" />
                </div>
            </div>
            </div>
            {/* <div id="blogherads-branding-container"></div> */}
            
        </footer>
    );
}

export default Footer